'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setLatestMessage = undefined;

var _set = require('transmute/set');

var _set2 = _interopRequireDefault(_set);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setLatestMessage = exports.setLatestMessage = (0, _set2.default)('latestMessage');